<template>
    <div class="topright_wrap">
        <div class="topright_wrap_title">不良品分析 <span style="font-size:14px">近10天</span></div>
        <div class="topright_wrap_block1">
            <div id="rightChart1"></div>
        </div>
        <div class="topright_wrap_block2">
            <div id="rightChart2"></div>
        </div>
    </div>
</template>

<script>
import { nongoodAnalysis,orderAnalysis} from '@/api/basicData';
export default {
    data() {
        return {
            chart1: null,
            chart2: null,
            userData:JSON.parse(window.localStorage.getItem('userdata')),
            option2:{},
            nongoodAnalysisList:[],
            tenDays:[],
            nongoodNumData:[],
            nongoodRateData:[],
            monthArray:[],
        }
    },
    mounted() {
      // this.getOrderAnalysis()
      this.getNongoodAnalysis()
      this.initChart1()
      this.initChart2()
    },
    methods: {
        formatterDate(day){
          return this.tenDays[day-1]
        },
        initChart1() {
            var _this = this
            this.chart1 = this.$echarts.init(document.getElementById("rightChart1"));
            let option = {
                tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
                },
                title: [
                    {
                        text: '不良品趋势图('+ this.monthArray.join(' 至 ') +')',
                        left: '0%',
                        top: '0',
                        textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                        color: '#fff'
                        }
                    }
                ],
                tooltip: {
                  trigger: "axis",
                  formatter: function (params) {
                    var result = ''
                    params.forEach(function (item) {
                      if(item.seriesName == '不良品数'){
                        result += _this.formatterDate(item.axisValue) + "</br>";
                        result += item.marker + item.seriesName + ':' +  item.data ;
                      }else{
                        result += "</br>"
                        result += item.marker + item.seriesName + ':' +  item.data + '%';
                      }

                    })
                    return result
                  },
                },
                grid: {
                left: '5%',
                right: '4%',
                bottom: '0%',
                containLabel: true
                },
                legend: {
                    orient: 'horizontal',
                    right: '20%',
                    y: '0',
                    itemWidth: 16, // 设置图例图形的宽
                    itemHeight: 16, // 设置图例图形的高
                    textStyle: {
                        color: '#fff' // 图例文字颜色
                    },
                    // itemGap设置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
                    itemGap: 10,
                    data: ['不良品数', '不良品率']
                },
                xAxis: [
                {
                    type: 'category',
                    boundaryGap: ['0%', '10%'],
                    data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                        color: "#232447",
                        }
                    },
                    axisLabel: {
                        show: true,
                        margin: 5, //刻度标签与轴线之间的距离
                        textStyle: {
                        color: "#9a99a8",
                        },
                    },
                }
                ],
                yAxis: [
                {
                    type: 'value',
                    name: '不良品数',
                    position: 'left',
                    nameTextStyle: {
                    padding: [0, 0, 0, -40] // 四个数字分别为上右下左与原位置距离
                    },
                    nameGap: 10, // y轴name与横纵坐标轴线的间距
                    nameLocation: 'end', // y轴name处于y轴的什么位置
                    silent: false,
                    clickable: true,
                    alignTicks: true,
                    splitLine: {
                        show: true,
                        lineStyle: {
                        color: "#686a75",
                        type: "dashed",
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                        color: "#686a75",
                        }
                    },
                    axisLabel: {
                        show: true,
                        formatter: '{value}',
                        textStyle: {
                        color: "#686a75"
                        }
                    },
                },
                {
                    type: 'value',
                    name: '不良品率',
                    nameTextStyle: {
                    padding: [0, -40, 0, 0] // 四个数字分别为上右下左与原位置距离
                    },
                    nameGap: 10, // y轴name与横纵坐标轴线的间距
                    nameLocation: 'end', // y轴name处于y轴的什么位置
                    position: 'right',
                    alignTicks: true,
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                        color: "#686a75",
                        }
                    },
                    axisLabel: {
                        show: true,
                        formatter: '{value}',
                        textStyle: {
                        color: "#686a75"
                        }
                    },
                }
                ],
                dataZoom: [
                    {
                        orient: "horizontal",
                        show: false, //控制滚动条显示隐藏
                        realtime: true, //拖动滚动条时是否动态的更新图表数据
                        end: 100, //滚动条结束位置
                        start: 0, //滚动条开始位置
                        zoomLock: true, //控制面板是否进行缩放
                    },
                    {
                        type: 'inside', //鼠标滚轮
                        realtime: true,
                    }
                ],
                series: [
                {
                    name: '不良品数',
                    type: 'bar',
                    data: this.nongoodNumData,
                    barWidth: '12',
                    itemStyle: {
                    normal: {
                        color: '#1cc0f2'
                    }
                    }
                },
                {
                    name: '不良品率',
                    type: 'line',
                    yAxisIndex: 1,
                    data: this.nongoodRateData,
                    itemStyle: {
                        normal: {
                            color: '#7cfcb2'
                        }
                    }
                }
                ]
            }
            this.chart1.setOption(option);
            let that = this;
            window.addEventListener("resize", function () {
                that.chart1.resize();
            });
        },
        initChart2() {
            this.chart2 = this.$echarts.init(document.getElementById("rightChart2"));
            let colorArr = [
            '#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae',
            '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570',
            '#c4ccd3', '#f05b72', '#ef5b9c', '#f47920', '#905a3d',
            '#fab27b', '#2a5caa', '#444693', '#726930', '#b2d235',
            '#6d8346', '#ac6767', '#1d953f', '#6950a1', '#91808d'
            ];
            this.option2 = {
                tooltip: {
                trigger: "item",
                formatter: "{b}: {c}项 ({d}%)",
                },
                title: [
                    {
                        text: '不良品项分布图',
                        left: '0%',
                        top: '0',
                        textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                        color: '#fff'
                        }
                    }
                ],
                legend: [{
                    show: true,
                    // icon: "circle",
                    itemWidth: 14,
                    itemHeight: 6,
                    y: "center", //延Y轴
                    x: '75%', //居左显示
                    orient: "vertical", //horizontal,vertical
                    textStyle: {
                        fontSize: "12",
                        color: "#fff"
                    },
                    },
                ],
                color: colorArr,
                series: [
                {
                    type: "pie",
                    // roseType: 'area',
                    radius: ["20%", "50%"],
                    center: ["30%", "52%"],
                    avoidLabelOverlap: false,
                    data: this.nongoodAnalysisList,
                    label: {
                      show: true,
                      formatter: "{c}:({d}%)",
                      textStyle: {
                          color: "#fff",
                          align: "right",
                          fontSize: 12,
                      },
                    },
                },
                ],
            };
            this.chart2.setOption(this.option2);
            let that = this;
            window.addEventListener("resize", function () {
                that.chart2.resize();
            });
        },
        // 不良品分布
        async getNongoodAnalysis(){
          var data = {
            factoryId:this.userData.factoryId
          }
          await nongoodAnalysis(data).then(res => {
            if(res.code == 200){
              var aggEnter = res.data.aggEnter
              if(aggEnter && aggEnter.length!=0){
                this.nongoodNumData = aggEnter.map(function(item){return item.nongoodNum})
                this.nongoodRateData = aggEnter.map(function(item){return item.nongoodRate})
                this.tenDays = aggEnter.map(function(item){return item.createDate})
                var tenDays = JSON.parse(JSON.stringify(this.tenDays))
                this.monthArray = []
                tenDays.map(function(item){
                  var tem = item.substring(0,7)
                  if(this.monthArray.indexOf(tem) == -1){
                    this.monthArray.push(tem)
                  }
                }.bind(this))
              }
              this.initChart1()

              this.nongoodAnalysisList = []
              for(var i in res.data.aggNongood){
                var tem = {
                  name:i,
                  value:res.data.aggNongood[i],
                }
                this.nongoodAnalysisList.push(tem)
              }
              this.option2.series[0].data = this.nongoodAnalysisList
              this.$nextTick(function(){
                this.chart2.setOption(this.option2,true);
              })
            }else{
              this.$message.error('查询失败！')
            }
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err)
          })
        },
        // 不良品分析 近10天
        // async getOrderAnalysis(){
        //   var data = {
        //     factoryId:this.userData.factoryId
        //   }
        //   await orderAnalysis(data).then(res => {
        //     if(res.code == 200){
        //       var aggEnter = res.data.aggEnter
        //       if(aggEnter && aggEnter.length!=0){
        //         this.nongoodNumData = aggEnter.map(function(item){return item.nongoodNum})
        //         this.nongoodRateData = aggEnter.map(function(item){return item.nongoodRate})
        //         this.tenDays = aggEnter.map(function(item){return item.createDate})
        //         var tenDays = JSON.parse(JSON.stringify(this.tenDays))
        //         this.monthArray = []
        //         tenDays.map(function(item){
        //           var tem = item.substring(0,7)
        //           if(this.monthArray.indexOf(tem) == -1){
        //             this.monthArray.push(tem)
        //           }
        //         }.bind(this))
        //       }
        //       this.initChart1()
        //     }else{
        //       this.$message.error('查询失败！')
        //     }
        //     this.loading = false
        //   })
        //   .catch(err => {
        //     this.loading = false
        //     this.$message.error(err)
        //   })
        // },
    }
}
</script>

<style scoped>
.topright_wrap{
    width: 100%;
    height: 100%;
    padding: 2%;
    color: #fff;
    font-size: 12px;
    box-sizing: border-box;
}
.topright_wrap_title {
    width: 95%;
    color: #04f9fe;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 10px;
    margin-left: 10px;
    padding-bottom: 5px;
    font-weight: 600;
    border-bottom: 1px solid rgba(4,249,254,.4);
}
.topright_wrap_block1 {
    height: 45%;
    width: 95%;
    margin-bottom: 10px;
    padding-bottom: 5px;
    margin-left: 10px;
    border-bottom: 1px solid rgba(4,249,254,.4);
}
.topright_wrap_block2 {
    height: 41%;
    width: 100%;
    margin-bottom: 10px;
    padding-bottom: 5px;
    margin-left: 10px;
}
#rightChart1 {
    height: 100%;
    width: 100%;
}
#rightChart2 {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/workshopSignage/workshopSignage/components/topright.vue